import { localeSpecificGroup } from 'utils/override';
import { staticText } from 'utils/staticText';
import { baseTranslations } from './base';

export const CONTENT_MHG = localeSpecificGroup(baseTranslations);
export const CONTENT_MHG_STATIC = staticText(baseTranslations);

export default CONTENT_MHG;
